import moment from 'moment';
// @ts-ignore
import Zemen from 'zemen';

/**
 * Converts a fiscal year start month and calendar type to a date range.
 * @param fiscalYear - The fiscal year start month (e.g. 'july', 'september')
 * @param fiscalYearCalendar - 'gregorian' or 'ethiopian'
 * @returns { fromDate: Date, toDate: Date }
 */
export function getFiscalYearDateRange({ fiscalYear, fiscalYearCalendar, year = undefined }: {
  fiscalYear: string;
  fiscalYearCalendar: string;
  year?: number;
}) {
  // Default to current year if not provided
  const now = moment();
  let startYear = year || now.year();

  if (fiscalYearCalendar === 'gregorian') {
    // Fiscal year starts at fiscalYear (e.g. 'july') in Gregorian
    const startMonth = moment().month(fiscalYear).startOf('month');
    // If current month is before fiscalYear, use previous year
    if (now.month() < startMonth.month()) {
      startYear = startYear - 1;
    }
    const fromDate = moment({ year: startYear, month: startMonth.month(), day: 1 });
    const toDate = fromDate.clone().add(1, 'year').subtract(1, 'day').endOf('day');
    return { fromDate: fromDate.toDate(), toDate: toDate.toDate() };
  }

  if (fiscalYearCalendar === 'ethiopian') {
    // Ethiopian months: add 4 to GC month to get EC month
    // e.g. July (7) + 4 = 11 (Hamle), September (9) + 4 = 13 (Pagume)
    const gcMonth = moment().month(fiscalYear).month() + 1; // moment months are 0-based
    let etMonth = gcMonth + 3;
    let etYear = startYear - 8; // EC year is GC year - 8
    if (etMonth > 13) {
      etMonth = etMonth - 13;
      etYear += 1;
    }

    const fromDate = Zemen.toGC(etYear-1, etMonth, 1);
    // End date: next EC year, same month, minus 1 day

    const toDate = moment(Zemen.toGC(etYear, etMonth-1, 30)).toDate();
    return { fromDate, toDate };
  }

  throw new Error('Unsupported fiscal year calendar: ' + fiscalYearCalendar);
} 